<template>
  <div>

    <!--breadcrumb start-->
    <div class="breadcrumb-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-text-center d-align-center">
            <h2 class="text-center"><span>{{$t("faq.Title")}}</span></h2>
          </div>
          </div>
      </div>
    </div>
      <!--breadcrumb end -->

      <!-- sign in -->
     <section id="faq" class="team">
        <div class="innerpage-decor">
          <div style="bottom: inherit;" class="innerpage-circle1"><img :src='"../../assets/images/Testimonial2-blue.png"' alt=""></div>
          <div style="bottom: inherit;" class="innerpage-circle2"><img :src='"../../assets/images/Testimonial1-blue.png"' alt=""></div>
          <div style="bottom: 50%; left: 80%" class="innerpage-circle2"><img :src='"../../assets/images/Testimonial1-blue.png"' alt=""></div>
        </div>
        <!--faq in -->
        <div class="faq">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div role="tablist" id="accordion">
                  <div class="card border-theme mb-3 radius-0">
                    <div v-b-toggle.collapseOne  class="card-header" role="tab" >
                      <a class="">{{$t("faq.question.1.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>

                    <b-collapse id="collapseOne" role="tabpanel"  accordion="my-accordion" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.1.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div v-b-toggle.collapseTwo class="card-header" role="tab" >
                      <a class="" >{{$t("faq.question.2.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseTwo" class="collapse show" accordion="my-accordion" role="tabpanel" aria-labelledby="headingTwo" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.2.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div  v-b-toggle.collapseThree class="card-header" >
                      <a class="" >{{$t("faq.question.3.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseThree" class="collapse show" accordion="my-accordion" aria-labelledby="headingThree" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.3.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div  class="card-header" v-b-toggle.collapseFour >
                      <a class="" >{{$t("faq.question.4.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseFour" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingFour" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.4.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div  class="card-header" v-b-toggle.collapseFive >
                      <a class="" >{{$t("faq.question.5.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseFive" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingFive" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.5.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div  class="card-header" v-b-toggle.collapseSix >
                      <a class="" >{{$t("faq.question.6.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseSix" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingSix" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.6.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div  class="card-header" v-b-toggle.collapseSeven >
                      <a class="" >{{$t("faq.question.7.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseSeven" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingSeven" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.7.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme mb-3 radius-0">
                    <div  class="card-header" v-b-toggle.collapseEight >
                      <a class="" >{{$t("faq.question.8.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseEight" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingEight" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.8.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                  <div class="card border-theme radius-0">
                    <div  class="card-header" v-b-toggle.collapseNine >
                      <a class="" >{{$t("faq.question.9.Title")}}<i class="fa fa-angle-down float-right"></i></a>
                    </div>
                    <b-collapse id="collapseNine" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingNine" data-parent="#accordion">
                      <div class="card-body">
                        {{$t("faq.question.9.Body")}}
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- faq up -->
      </section>
      <!-- sign up -->
    <!--blog Section end-->

    <js/>
    <!--Footer Section End-->
  </div>
</template>
<script>

export default {
  name: 'FaqInfo'
}
</script>



// WEBPACK FOOTER //
// src/components/faqPage/faqinfo.vue